document.addEventListener('DOMContentLoaded', function () {
    var app = document.getElementById('kai-multimeter-quiz-app');
    if (!app) return;

    var questions = [
      {
  title: 'Question 1: Which test lead setup is correct for measuring current?',
  text: 'You want to measure a small current in the mA range. Which test lead setup is correct?',
  options: [
    {
      label: 'A',
      text: '',
      image: 'https://cdn.shopify.com/s/files/1/0587/6252/6897/files/the-red-test-lead-is-plugged-into-the-ohm-jack.webp?v=1779779586',
      alt: 'Incorrect multimeter lead setup with the red test lead plugged into the ohm jack',
      correct: false,
      feedback: 'The Ω jack is used for measurements such as resistance, continuity, and voltage on many meters. For current measurement, the red lead must be plugged into the correct current jack.'
    },
    {
      label: 'B',
      text: '',
      image: 'https://cdn.shopify.com/s/files/1/0587/6252/6897/files/the-red-lead-is-in-the-ma-jack.webp?v=1779779586',
      alt: 'Correct multimeter lead setup with the red lead in the mA jack for measuring small current',
      correct: true,
      feedback: 'For a small current measurement, the black lead should be in COM, and the red lead should be in the mA jack.'
    },
    {
      label: 'C',
      text: '',
      image: 'https://cdn.shopify.com/s/files/1/0587/6252/6897/files/the-red-in-com.webp?v=1779779586',
      alt: 'Incorrect multimeter lead setup with the red test lead plugged into the COM jack',
      correct: false,
      feedback: 'The COM jack is normally for the black test lead. The red lead should be plugged into the correct input jack for the measurement you want to make.'
    }
  ]
},
      {
        title: 'Question 2: How should a multimeter be connected when measuring current?',
        text: 'When measuring current, how should the multimeter be connected to the circuit?',
        options: [
          {
            label: 'A',
            text: 'In parallel with the component',
            correct: false,
            feedback: 'Parallel connection is used for voltage measurement, not current measurement. Current should be measured in series.'
          },
          {
            label: 'B',
            text: 'In series with the component',
            correct: true,
            feedback: 'Current is measured in series, so the multimeter becomes part of the circuit path.'
          },
          {
            label: 'C',
            text: 'Across the power source, like a voltage test',
            correct: false,
            feedback: 'Do not place a meter set to current mode directly across a power source. This can blow the fuse or damage the meter.'
          }
        ]
      },
      {
  title: 'Question 3: Which fuse should you use for the 10A input?',
  text: 'The fuse for the 10A high-current input is blown. Which replacement fuse should you choose?',
  image: 'https://cdn.shopify.com/s/files/1/0587/6252/6897/files/jack-labels_a8e23709-4dc7-457e-82bf-3c52df8a7121.webp?v=1779788769',
  alt: 'Close-up of multimeter input jack labels showing the fuse ratings for the mA and 10A inputs',
  options: [
    {
      label: 'A',
      text: '400mA 250V',
      correct: false,
      feedback: 'This rating is for the lower-current mA input, not the 10A high-current input.'
    },
    {
      label: 'B',
      text: '10A 250V',
      correct: true,
      feedback: 'This matches the rating printed next to the 10A input jack. When replacing a multimeter fuse, choose the same current and voltage rating.'
    },
    {
      label: 'C',
      text: '10A 300V',
      correct: false,
      feedback: 'The current rating matches, but the voltage rating does not match the rating shown next to the 10A input.'
    },
    {
      label: 'D',
      text: '20A 300V',
      correct: false,
      feedback: 'Do not use a higher current rating just because the fuse fits. A higher-rated fuse may not protect the meter correctly.'
    }
  ]
},
      {
  title: 'Question 4: Which resistance range should you choose?',
  text: 'Your multimeter has these manual resistance ranges: 200Ω, 2kΩ, 20kΩ, 200kΩ, and 2MΩ. You want to measure a 45kΩ resistor. Which range should you choose?',
  options: [
    {
      label: 'A',
      text: '20kΩ',
      correct: false,
      feedback: '45kΩ is higher than 20kΩ, so this range is too low and may show an over-range reading.'
    },
    {
      label: 'B',
      text: '200kΩ',
      correct: true,
      feedback: 'On a manual-ranging multimeter, choose the next range higher than the value you expect. Since 45kΩ is higher than 20kΩ but lower than 200kΩ, 200kΩ is the best choice.'
    },
    {
      label: 'C',
      text: '2MΩ',
      correct: false,
      feedback: 'This range can measure 45kΩ, but it is higher than necessary. The 200kΩ range is a better choice for this value.'
    },
    {
      label: 'D',
      text: '200Ω',
      correct: false,
      feedback: 'This range is much lower than 45kΩ, so it is not suitable.'
    }
  ]
},
      {
        title: 'Question 5: Why does the reading keep jumping?',
        text: 'Why might the reading on a multimeter keep jumping?',
        options: [
          {
            label: 'A',
            text: 'The probes may not be making stable contact.',
            correct: false,
            feedback: 'This can be one reason, but it is not the complete answer. Loose probe contact can cause unstable readings.'
          },
          {
            label: 'B',
            text: 'The meter may be auto-ranging.',
            correct: false,
            feedback: 'This can be one reason, but it is not the complete answer. Auto-ranging can cause the display to change while the meter selects the best range.'
          },
          {
            label: 'C',
            text: 'The circuit or component may not be stable.',
            correct: false,
            feedback: 'This can be one reason, but it is not the complete answer. A changing circuit or component can make the reading move.'
          },
          {
            label: 'D',
            text: 'All of the above.',
            correct: true,
            feedback: 'A jumping reading can be caused by loose probe contact, auto-ranging, electrical noise, or an unstable circuit or component.'
          }
        ]
      },
      {
        title: 'Question 6: What should you check before starting the next test?',
        text: 'After finishing one measurement and before starting the next one, what should you check first?',
        options: [
          {
            label: 'A',
            text: 'Whether the test leads are in the correct jacks',
            correct: false,
            feedback: 'This is important, especially after measuring current, but it is not the only thing to check.'
          },
          {
            label: 'B',
            text: 'Whether the dial is set to the correct function',
            correct: false,
            feedback: 'This is important, but you should also check whether the test leads are in the correct jacks.'
          },
          {
            label: 'C',
            text: 'Both A and B',
            correct: true,
            feedback: 'Before starting a new test, check both the test lead jacks and the dial setting. This is especially important after measuring current.'
          }
        ]
      }
    ];

    var currentIndex = 0;
    var score = 0;
    var answered = false;

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function renderQuestion() {
      answered = false;

      var question = questions[currentIndex];
      var progressPercent = ((currentIndex + 1) / questions.length) * 100;

      var optionsHtml = question.options.map(function (option, index) {
        var imageHtml = '';

        if (option.image && option.image.indexOf('PASTE_IMAGE_URL') === -1) {
          imageHtml = '<img class="krq-option-img" src="' + escapeHtml(option.image) + '" alt="' + escapeHtml(option.alt || '') + '">';
        }

        return (
          '<button type="button" class="krq-option" data-index="' + index + '">' +
            '<span class="krq-letter">' + escapeHtml(option.label) + '</span>' +
            '<span class="krq-option-content"><strong>' + escapeHtml(option.text) + '</strong>' + imageHtml + '</span>' +
            '<span class="krq-status" aria-hidden="true"></span>' +
          '</button>'
        );
      }).join('');

      app.innerHTML =
        '<div class="krq-card">' +
          '<div class="krq-topbar">' +
            '<span>Question ' + (currentIndex + 1) + ' of ' + questions.length + '</span>' +
            '<div class="krq-progress" aria-hidden="true"><span style="width:' + progressPercent + '%"></span></div>' +
            '<span>Score: ' + score + '</span>' +
          '</div>' +
          '<div class="krq-body">' +
            '<h3 class="krq-question-title">' + escapeHtml(question.title) + '</h3>' +
            '<p class="krq-question-text">' + escapeHtml(question.text) + '</p>' +
(question.image ? '<img class="krq-question-img" src="' + escapeHtml(question.image) + '" alt="' + escapeHtml(question.alt || '') + '">' : '') +
            '<div class="krq-options">' + optionsHtml + '</div>' +
            '<div class="krq-explanation" id="krq-explanation"></div>' +
            '<div class="krq-actions">' +
              '<button type="button" class="krq-btn" id="krq-next" style="display:none;">' +
                (currentIndex === questions.length - 1 ? 'See results' : 'Next question') +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';

      bindQuestionEvents();
    }

    function bindQuestionEvents() {
      var optionButtons = app.querySelectorAll('.krq-option');
      var explanation = app.querySelector('#krq-explanation');
      var nextButton = app.querySelector('#krq-next');
      var question = questions[currentIndex];

      optionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (answered) return;

          answered = true;

          var selectedIndex = Number(button.getAttribute('data-index'));
          var selectedOption = question.options[selectedIndex];
          var isCorrect = selectedOption.correct;

          if (isCorrect) {
            score += 1;
          }

          optionButtons.forEach(function (btn, index) {
            var option = question.options[index];
            var status = btn.querySelector('.krq-status');

            btn.disabled = true;

            if (option.correct) {
              btn.classList.add('is-correct');
              if (status) status.textContent = '✓';
            } else {
              btn.classList.add('is-muted');
            }

            if (index === selectedIndex && !option.correct) {
              btn.classList.remove('is-muted');
              btn.classList.add('is-wrong');
              if (status) status.textContent = '✕';
            }
          });

          explanation.className = 'krq-explanation is-visible ' + (isCorrect ? 'is-correct' : 'is-wrong');

          explanation.innerHTML =
            '<div class="krq-explanation-title">' +
              '<span class="krq-explanation-icon">' + (isCorrect ? '✓' : '✕') + '</span>' +
              '<span>' + (isCorrect ? 'Correct answer' : 'Not quite') + '</span>' +
            '</div>' +
            '<p>' + escapeHtml(selectedOption.feedback) + '</p>';

          nextButton.style.display = 'inline-flex';
        });
      });

      nextButton.addEventListener('click', function () {
        if (currentIndex < questions.length - 1) {
          currentIndex += 1;
          renderQuestion();
        } else {
          renderResult();
        }
      });
    }

    function renderResult() {
      var percent = Math.round((score / questions.length) * 100);
      var resultMessage = '';

      if (percent === 100) {
        resultMessage = 'Excellent. You understand the basic multimeter setup and safety checks very well.';
      } else if (percent >= 70) {
        resultMessage = 'Good job. Review the questions you missed before using a multimeter for a new measurement.';
      } else {
        resultMessage = 'Keep practicing. Pay special attention to test lead positions, dial settings, and current measurement safety.';
      }

      app.innerHTML =
        '<div class="krq-card">' +
          '<div class="krq-result">' +
            '<h3>Your quiz result</h3>' +
            '<div class="krq-result-score">' + score + '/' + questions.length + '</div>' +
            '<p>You scored ' + percent + '%. ' + escapeHtml(resultMessage) + '</p>' +
            '<button type="button" class="krq-btn" id="krq-restart">Try again</button>' +
          '</div>' +
        '</div>';

      app.querySelector('#krq-restart').addEventListener('click', function () {
        currentIndex = 0;
        score = 0;
        answered = false;
        renderQuestion();
      });
    }

    renderQuestion();
  });